import { getDatabase } from "firebase/database";
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAfoQEfQ5EyT1upftOr3lMDU42IjO5TOUI",
  authDomain: "qr-databaseadjustable.firebaseapp.com",
  databaseURL: "https://qr-databaseadjustable-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "qr-databaseadjustable",
  storageBucket: "qr-databaseadjustable.firebasestorage.app",
  messagingSenderId: "466494729510",
  appId: "1:466494729510:web:35edc1687d60906d1165e7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

// Export the app instance as well if needed elsewhere
export default app;
